import { CompetitionMaster } from "../../Types/CompetitionMaster";
import { formatDate } from "../../utils/date-utils";
import { Center, Container } from "./Navbar.style";

function Navbar({
  competitionMaster,
}: {
  competitionMaster?: CompetitionMaster;
}) {
  const name = competitionMaster?.name ?? "HSBC GOLF TOURNAMENT";
  const golfCourse = competitionMaster?.golfCourse?.gcName ?? "Golf Course";

  const date = formatDate(new Date(competitionMaster?.startDate?.iso || ""));

  return (
    <Container>
      <Center style={{ fontSize: "20px" }}>{golfCourse}</Center>
      <Center>Leaderboard: {name}</Center>
      <Center style={{ fontSize: "20px" }}>{date}</Center>
    </Container>
  );
}

export default Navbar;
